// React
import React from "react";
// MUI
import { Card, Stack, Button, Container, Typography } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Components
import GoInLineTable from "../../../common/GoInLineTable/GoInLineTable";
// Utils
import { DISCOUNT_LINE_TABLE_HEADS } from "./Discount.utils";


const DiscountLines = ({ discountLines }) => {

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                </Stack>
                <Card>
                    <GoInLineTable tableHeads={DISCOUNT_LINE_TABLE_HEADS} tableDatas={discountLines} />
                </Card>
            </Container>
        </React.Fragment>
    );
}

export default DiscountLines;